module.exports = __webpack_public_path__ + "static/media/mandala.a688a25e.jpg";